export default __webpack_public_path__ + "../img/70885d3e45b95f71f599b1890e793190.png";